import type { User, UserGroup } from '@stuut/api/models';
import { UserRoleLabels, UserRoleLevel } from '@stuut/api/models';

export const getUserGroups = (users: User[]) => {
  const ret: UserGroup[] = [];

  for (const value of Object.values(UserRoleLevel)) {
    ret.push({
      label: UserRoleLabels[value],
      users: users.filter((u) => u.userRole === value),
    });
  }

  return ret;
};
